module.exports = __webpack_public_path__ + "static/media/message.e6b5153a.svg";